import styled from 'styled-components';

import { media } from '@simplywallst/ui-core';

export const TitleContainer = styled('div')`
  > div {
    display: grid;
    place-content: end;
    justify-content: start;
    min-height: 210px;
    padding: ${({ theme }) => `${theme.x1}px ${theme.x3}px`};

    ${media.mdDown`
      min-height: 128px;
    `}
  }
`;

export const AuthorPhoto = styled('img')`
  object-fit: cover;
  border-radius: 100%;
`;

export const AuthorLink = styled('a')`
  text-decoration: none;
`;

export const ArticleThumbnail = styled('img')`
  object-fit: cover;
  border-radius: ${({ theme }) => theme.x0_5}px;
`;
